import React from 'react';
import { useNavigate } from 'react-router-dom';

import useNemo from '../../../../api/useNemo';
import PinkDotsIllustration from '../../../../assets/svg-components/intro/select_website_dots.svg';
import { Button } from '../../../../components/button/button';
import { Dropdown } from '../../../../components/dropdown/dropdown';
import { Label } from '../../../../components/label/label';
import { Translate } from '../../../../components/translate';
import { ROUTE } from '../../../../router';
import { StoreContext } from '../../../../store/store';
import { DomainList } from '../../../../store/types';

interface GenerateReportProps {
  domains: DomainList | [];
  token: string;
}

export const GenerateReport: React.FC<GenerateReportProps> = ({ domains, token }) => {
  const navigate = useNavigate();

  const { state } = React.useContext(StoreContext);
  const request = useNemo();

  const [domainId, setDomainId] = React.useState('');

  React.useEffect(() => {
    if (domains.length > 0) {
      const initialDomainId = domains[0].id;
      setDomainId(initialDomainId);
    }
  }, [domains]);

  const handleDomainChange = (event) => {
    setDomainId(event.target.value);
  };

  const handleClick = () => {
    request({
      endpoint: `/yearly-recap/${domainId}/generate?_client_token=${token}`,
      method: 'GET'
    }).then(({ data }) => {
      navigate(state.config.initialPath + ROUTE.RECAP_PERSONAL.replace(':domain', data.domain));
      setTimeout(() => {
        const section = document.querySelector('.rc-speed-section');
        if (section) {
          section.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
        }
      }, 0);
    });
  };

  return (
    <div className="rc-intro-section__card">
      <div className="rc-intro-section__card-dropdown">
        <Label className="rc-intro-section__card-dropdown-label">
          <Translate id="translate.intro.section.dropdown.label" />
        </Label>
        <Dropdown options={domains} optionValue="id" optionLabel="domain" onChange={handleDomainChange} />
      </div>

      <Button className="rc-intro-section__card-button" onClick={handleClick}>
        <Translate id="translate.intro.button.view.custom.report" />
      </Button>

      <PinkDotsIllustration className="rc-intro-section__card-pink-dots" />
    </div>
  );
};
